document.addEventListener('click', (event) => {
	const actionElement = event.target.closest('[data-link-slider-action]')
	if (actionElement) {
		const sliderElement = actionElement.closest('[data-link-slider]')
		if (sliderElement) {
			const current = parseInt(sliderElement.getAttribute('data-link-slider'))
			const itemElements = sliderElement.querySelectorAll('[data-slider-item]')
			const action = actionElement.getAttribute('data-link-slider-action')
			switch (action) {
				case 'prev':
					sliderElement.setAttribute('data-link-slider', current > 0 ? current - 1 : 0)
					break;
				case 'next':
					sliderElement.setAttribute('data-link-slider', current < (itemElements.length - 1) ? current + 1 : (itemElements.length - 1))
					break;
				default:
					sliderElement.setAttribute('data-link-slider', parseInt(action))
					break;
			}
		}
	}
});
